/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Caption_OutInputs */

const en_hero_caption_out = /** @type {(inputs: Hero_Caption_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Then it travels outward: to brands, to buyers, to every system around them.`)
};

/**
* | output |
* | --- |
* | "Then it travels outward: to brands, to buyers, to every system around them." |
*
* @param {Hero_Caption_OutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const hero_caption_out = /** @type {((inputs?: Hero_Caption_OutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Caption_OutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hero_caption_out(inputs)
});